/*
 * rheincool — Produktgalerie
 * - Thumbnails wechseln das Hauptbild (Tabs-Pattern)
 * - Mobil: Swipe via Scroll-Snap, Dots zeigen Position
 * - Zoom-on-Hover auf dem aktiven Bild (Desktop, nur mit Feinzeiger)
 */
class RcGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.dotsContainer = this.querySelector('[data-gallery-dots]');

    this.buildDots();
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.goTo(thumb.dataset.mediaId));
    });
    if (this.track) {
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }
    this.initZoom();
  }

  buildDots() {
    if (!this.dotsContainer || this.slides.length < 2) return;
    this.slides.forEach((slide, index) => {
      const dot = document.createElement('span');
      dot.className = index === 0 ? 'rc-gallery__dot is-active' : 'rc-gallery__dot';
      this.dotsContainer.appendChild(dot);
    });
    this.dots = Array.from(this.dotsContainer.children);
  }

  goTo(mediaId) {
    const index = this.slides.findIndex((s) => s.dataset.mediaId === mediaId);
    if (index < 0) return;
    this.setActive(index);
    this.track.scrollTo({
      left: this.slides[index].offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  onScroll() {
    if (this.scrollTimer) cancelAnimationFrame(this.scrollTimer);
    this.scrollTimer = requestAnimationFrame(() => {
      const index = Math.round(this.track.scrollLeft / this.track.offsetWidth);
      this.setActive(Math.min(index, this.slides.length - 1), true);
    });
  }

  setActive(index, fromScroll = false) {
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    if (this.dots) {
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
    if (!fromScroll && this.track && window.matchMedia('(min-width: 990px)').matches) {
      // Desktop: kein horizontales Scrollen — Slides werden gestapelt umgeschaltet
    }
  }

  initZoom() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    this.querySelectorAll('[data-zoomable]').forEach((img) => {
      const slide = img.closest('[data-gallery-slide]');
      slide.addEventListener('mousemove', (event) => {
        const rect = slide.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });
      slide.addEventListener('mouseenter', () => img.classList.add('is-zoomed'));
      slide.addEventListener('mouseleave', () => img.classList.remove('is-zoomed'));
    });
  }
}

customElements.define('rc-gallery', RcGallery);
